import ImageDescriptionBullets from '../ImageDescriptionBullets/ImageDescriptionBullets'

function UPIInteroperabilty({ selectedCard, handleNavigation }) {
  return (
    <ImageDescriptionBullets
      bulletstitle={selectedCard.bulletstitle}
      image={selectedCard.image}
      button={selectedCard.button}
      bulletssubsection={selectedCard.bulletssubsection}
      handleNavigation={handleNavigation}
    />
  )
}

export default UPIInteroperabilty
